import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fromComponent: true,
  fromComponentTrigger: 0,
};

const getStartedSlice = createSlice({
  name: "getStarted",
  initialState,
  reducers: {
    setGetStarted: (state, action) => {
      state.fromComponent = action.payload.fromComponent;
    },
    clearGetStarted: (state) => {
      state.fromComponent = false;
      state.fromComponentTrigger = Date.now();
    },
  },
});

export const { setGetStarted, clearGetStarted } = getStartedSlice.actions;
export default getStartedSlice.reducer;
